module.exports = __webpack_public_path__ + "assets/img/429c485737b13d2019b5043c2c6f7bc6.jpg";